module.exports = __webpack_public_path__ + "img/no-img-low.bdd62e0.jpg";